<article class="flex align-items-center">
  <img [src]="logoUrl" alt="Retailer logo" class="mr-2" />

  <!-- Desktop sidebar only. The mobile header shows the logo alone so the
       centered Tactiq logo stays symmetric (product feedback 2026-09-02). -->
  <div *twxIsNotMobile class="retailer">
    <p class="m-0 text-xs">Family Dollar</p>
    @if (homeName; as home) {
      <p class="m-0 line-height-1 font-semibold store">{{ home }}</p>
    } @else {
      <p class="m-0 line-height-1 font-semibold store">Store 3112</p>
    }
  </div>
</article>
